import { ApiService } from '../../../shared/service/api/apiService';
import { BurnInJob, BurnInValidationResult, BurnInSubtitle } from '../types/burnInTypes';

const SUBTITLE_BURNIN_API_PATH = '/api/v1/subtitle-burnin/jobs/';

class BurnInService extends ApiService<BurnInJob> {
  public async createSingleJob(contentId: number, subtitleId: number): Promise<BurnInJob> {
    return await this.createBySubPath<BurnInJob>('', {
      content_id: contentId,
      subtitle_id: subtitleId,
    });
  }

  public async createBatchJobs(
    seasonId: number,
    lang: string
  ): Promise<BurnInJob[]> {
    return await this.createBySubPath<BurnInJob[]>('batch/', {
      season_id: seasonId,
      lang,
    });
  }

  public async validate(
    seasonId: number,
    lang: string
  ): Promise<BurnInValidationResult> {
    const params = new URLSearchParams({
      season_id: seasonId.toString(),
      lang,
    });
    return await this.fetchBySubPathRaw<BurnInValidationResult>('../validate/', params);
  }

  public async fetchByVideo(videoId: number): Promise<BurnInJob[]> {
    return await this.fetchBySubPathRaw<BurnInJob[]>(`by-video/${videoId}/`);
  }

  public async fetchSubtitlesByContent(contentId: number): Promise<BurnInSubtitle[]> {
    return await this.fetchBySubPathRaw<BurnInSubtitle[]>(
      `../content/${contentId}/subtitles/`
    );
  }
}

export const burnInService = new BurnInService(SUBTITLE_BURNIN_API_PATH);
